import { render, staticRenderFns } from "./specialDataList.vue?vue&type=template&id=3910efed&"
import script from "./specialDataList.vue?vue&type=script&lang=js&"
export * from "./specialDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports